module.exports = __webpack_public_path__ + "static/media/energetic-animation.dad2ae46.webm";